// import { makeStyles } from "@mui/styles"
// import { Box } from "@fedsim/components"

// const useStyles = makeStyles({
//   root: {
//     "@media (prefers-reduced-motion: reduce)": {
//       "& *": {
//         animationDuration: "0.001ms !important",
//         animationIterationCount: "1 !important",
//         transitionDuration: "0.001ms !important",
//       },
//     },
//   },
// })

export function ReducedMotion({ children = null }) {
  return children
  // const classes = useStyles()
  // return <Box className={classes.root}>{children}</Box>
}

export default ReducedMotion
